import React, { useMemo } from "react";
import { PropTypes } from "prop-types";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import AppHOC from "../../../generics/AppHOC";
import Spinner from "../../../common/Spinner";
import ErrorComponent from "../../../common/ErrorComponent";
import NoDataAvailable from "../../../common/NoDataAvailable";
import { getColor } from "../../../utils/colors";
import { getCircuitsAvailability } from "../common/masterTableUtil";
import { useI18n } from "../../../i18n/useI18n";
import css from "../circuitsMagneticStyle.less";

const [HbrIcon] = reactWrapper(["hbr-icon"]);

const Availability = ({
  globalFilter: { selectedSite },
  reportData
}) => {
  const { tViews } = useI18n("views");

  const data = useMemo(() => {
    const uptimeData = {
      error: null,
      uptime: 0,
      textColor: ""
    };

    if (!reportData.loader) {
      uptimeData.error = reportData.error;
      if (!uptimeData.error) {
        const availability = selectedSite > -1
          ? getCircuitsAvailability(reportData, selectedSite, false, false, true)
          : getCircuitsAvailability(reportData, selectedSite, true, true, true);
        uptimeData.uptime = parseFloat(availability.current.toFixed(2));
        uptimeData.textColor = getColor(uptimeData.uptime, "availability");
      }
    }

    return uptimeData;
  }, [selectedSite, reportData]);

  return (
    <div
      className={`flex-column-full ${css.availability}`}
      data-testid="availability"
    >
      <div className="flex-items-two">
        <div className="hbr-type-h2" role="heading" aria-level="2">
          {tViews("circuit.aTitle")}
        </div>
      </div>
      <div className="flex-main-content flex-items-center">
        {reportData.loader ? (
          <Spinner />
        ) : data.error ? (
          <ErrorComponent
            {...data.error}
            width="110px"
            className="one-line-dashlet-error"
          />
        ) : reportData.data.length === 0 ? (
          <NoDataAvailable />
        ) : (
          <div
            className="flex-items-center hbr-type-h1"
            style={{ color: data.textColor }}
          >
            <div>
              {tViews("aUptimeSuffixValue", { resultCount: data.uptime })}
            </div>
            <HbrIcon
              name="trend-up"
              label={tViews("circuit.aUptimeSuffix")}
              aria-hidden="true"
            />
          </div>
        )}
      </div>
    </div>
  );
};

Availability.propTypes = {
  globalFilter: PropTypes.object.isRequired,
  reportData: PropTypes.object.isRequired
};

export default AppHOC(Availability);
